<div>
  @if (loginType == 1) {
    <p class="wrapper has-background dark-blue has-padding">Success: your profile was created</p>
  }
  @if (loginType == 3) {
    <p class="wrapper has-background dark-blue has-padding">Applicant Screening Dispute Request Form</p>
  }

  @if ((user || vendorUser) ) {
    <div class="wrapper has-padding">
      @if (user) {
        <h1  class="bofa--heading is-1">Applicant login</h1>
      }
      @if (vendorUser) {
        <h1  class="bofa--heading is-1">Login</h1>
      }
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        @if (user) {
          <p>If you have trouble accessing your application, please reach out to the contact listed in your invitation
          email.</p>
        }
        <p class="bottom-space">Required fields are followed by <abbr title="required">*</abbr>.</p>
        @if (loginType == 2 || loginType == 3) {
          <p class="bottom-space global-red">(Please note: This is the same user name and password established when you provided consent for your background check)</p>
        }
        @if (user) {
          <div>
            <mat-form-field class="flex-width max-width-400" >
              <mat-label>Username</mat-label>
              <input matInput value="{{user.email}}" disabled>
            </mat-form-field>
          </div>
        }
        @if (4 == loginType) {
          <div>
            <mat-form-field class="flex-width max-width-400"
              >
              <mat-label>Username</mat-label>
              <input matInput value="{{vendorUser.username}}" disabled>
              <mat-error>Please enter Username</mat-error>
            </mat-form-field>
          </div>
        }
        <div id="main-content"  (focusout)="onFocusOutMainContent($event)">
          <mat-form-field class="flex-width max-width-400">
            <mat-label id="password-label">Password</mat-label>
            <input matInput formControlName="password" type="password" required autocomplete="off" aria-labelledby="password-label" aria-required="true">
            @if (password.hasError('submittedCredentialError')) {
              <mat-error>Username/Password combination is
              wrong. Please try again</mat-error>
            }
            @if (password.hasError('required')) {
              <mat-error>Please enter your password</mat-error>
            }
          </mat-form-field>
        </div>
        @if (user) {
          <div class="is-taller mobile-flex">
            <button class="bofa--button primary large zoom-width" [disabled]="!form.valid">Login</button>
            <button type="button" [routerLink]="['/forgotPassword']" class="bofa--button secondary outlined zoom-width">I forgot my password</button>
            <button type="button" [routerLink]="['/changePassword']" class="bofa--button secondary outlined zoom-width">I want to change my password</button>
          </div>
        }
        @if (vendorUser) {
          <div class="is-taller mobile-flex">
            <button class="bofa--button primary large zoom-width" [disabled]="!form.valid">Login</button>
            <button type="button" [routerLink]="['/securityQuestions']" class="bofa--button secondary outlined zoom-width">I forgot my password</button>
            <button type="button" [routerLink]="['/changePassword']" class="bofa--button secondary outlined zoom-width">I want to change my password</button>
          </div>
        }
      </form>
    </div>
  } @else {
    Loading Applicant User...
  }
</div>
